export default __webpack_public_path__ + "static/media/assembly-logo.08cde7f0.svg";